module.exports = __webpack_public_path__ + "media/scholarship_winners/carlos-sw-f8ec7491.png";